import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import "../styles/Register.css";

export default function Register() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmSenha, setConfirmSenha] = useState('');
  const [tipo, setTipo] = useState('admin'); // valor padrão
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async () => {
    // ✅ Validações básicas
    if (!nome.trim() || !email.trim() || !senha.trim()) {
      alert('Preencha todos os campos');
      return;
    }

    if (senha !== confirmSenha) {
      alert('As senhas não coincidem');
      return;
    }

    setLoading(true);

    try {
      // 1️⃣ Cria usuário no Supabase Auth
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email,
        password: senha,
      });

      if (authError) throw authError;

      const userId = authData?.user?.id;
      if (!userId) throw new Error("Não foi possível obter o ID do usuário.");

      console.log("✅ Usuário Auth criado:", userId);

      // 2️⃣ Insere na tabela 'usuarios'
      // OBS: Com RLS ativo, a tabela precisa ter policy de INSERT:
      // with check (auth_id = auth.uid());
      const { error: insertError } = await supabase
        .from('usuarios')
        .insert([{
          nome: nome.trim(),
          email: email.trim(),
          tipo,
          auth_id: userId, // vínculo com Auth
        }]);

      if (insertError) throw insertError;

      console.log("✅ Usuário cadastrado na tabela 'usuarios'");

      alert('Conta criada com sucesso! Verifique seu e-mail para confirmação.');
      navigate('/login');

    } catch (error) {
      console.error("❌ Erro no registro:", error);
      alert(error.message || 'Erro ao registrar usuário. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-animated-register">
      <div className="register-container animate-fadeIn">
        <h2 className="register-title">Registrar</h2>

        <input
          type="text"
          placeholder="Nome de Usuário"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          className="register-input"
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="register-input"
        />

        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          className="register-input"
        />

        <input
          type="password"
          placeholder="Confirmar Senha"
          value={confirmSenha}
          onChange={(e) => setConfirmSenha(e.target.value)}
          className="register-input"
        />

        <select
          value={tipo}
          onChange={(e) => setTipo(e.target.value)}
          className="register-input"
        >
          <option value="admin">Admin</option>
          <option value="secretaria">Secretaria</option>
        </select>

        <button
          onClick={handleRegister}
          className="register-button"
          disabled={loading}
        >
          {loading ? 'Registrando...' : 'Registrar'}
        </button>

        <p className="register-footer">
          Já tem uma conta?{' '}
          <span className="register-link" onClick={() => navigate('/login')}>
            Login
          </span>
        </p>
      </div>
    </div>
  );
}
